export default __webpack_public_path__ + "static/media/opencv.e39300a2.svg";